import {
	isSketchArcObject,
	isSketchLineObject,
} from '../../../mesh/guards';
import type { SketchArcObject } from '../../../mesh/sketch/SketchArcObject';
import type { SketchLineObject } from '../../../mesh/sketch/SketchLineObject';
import type { SketchSlotObject } from '../../../mesh/sketch/SketchSlotObject';

/**
 * 按拓扑序号读取槽口内部边。
 * 说明：
 * 1. 槽口在 UI 上是一个复合对象；
 * 2. Convert Entities 持久化时记录 slot-edge 拓扑序号；
 * 3. 所有 create / rebuild / 基础关系恢复入口必须使用同一个解析口径。
 *
 * @param sourceSlot 槽口对象。
 * @param edgeIndex 边拓扑序号。
 * @returns 命中的线或圆弧边；不存在时返回 null。
 */
export function resolveSketchSlotEdgeByIndex(
	sourceSlot: SketchSlotObject,
	edgeIndex: number,
): SketchLineObject | SketchArcObject | null {
	const sourceEdge = sourceSlot.getEdges()[edgeIndex] ?? null;
	return sourceEdge && (isSketchLineObject(sourceEdge) || isSketchArcObject(sourceEdge))
		? sourceEdge
		: null;
}
